<script lang="ts">

</script>
<tr>
    <th scope="col">{'Prdouct'}</th>
    <th scope="col">{'Prdouct name'}</th>
    <th scope="col">{'Size'}</th>
    <th scope="col">{'Color'}</th>
    <th scope="col">{'Article number'}</th>
    <th scope="col">{'Units'}</th>
    <th scope="col">{'Price'}</th>
    <th scope="col"><i class="fa fa-angle-down" /></th>
</tr>